import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './components/login';
import WarrantyForm from './components/admin/WarrantyForm';
import Dashboard from './components/admin/Dashboard';
import Showrooms from './components/admin/Showrooms';
import User from './components/admin/User';
import WarrantyList from './components/admin/WarrantyList';
import WarrantyPrint from './components/admin/WarrantyPrint';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Admin Routes */}
        <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />
        <Route path="/admin/dashboard" element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        } />
        <Route path="/admin/showrooms" element={
          <PrivateRoute>
            <Showrooms />
          </PrivateRoute>
        } />
        <Route path="/admin/users" element={
          <PrivateRoute>
            <User />
          </PrivateRoute>
        } />
        <Route path="/admin/warranties" element={
          <PrivateRoute>
            <WarrantyList />
          </PrivateRoute>
        } />
        <Route path="/admin/warranty/create" element={<PrivateRoute><WarrantyForm /></PrivateRoute>} />
        <Route path="/admin/warranty/view/:id" element={<PrivateRoute><WarrantyForm viewOnly /></PrivateRoute>} />
        <Route path="/admin/warranty/edit/:id" element={<PrivateRoute><WarrantyForm /></PrivateRoute>} />
        <Route path="/admin/warranty/print/:id" element={<PrivateRoute><WarrantyPrint /></PrivateRoute>} />
        
        {/* Default Route */}
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;